import Axios from 'axios';

const API_URL =  process.env.API_URL + '/api/v1/';

class SetoranAwal {
  index() {
    return Axios.get(API_URL + 'setoranawal-list');
  }

  show(setoranawal) {
    return Axios.get(API_URL + `setoranawal/${setoranawal}`);
  }

  orderName() {
    return Axios.get(API_URL + 'setoranawal-ordername');
  }
}

export default new SetoranAwal();



// WEBPACK FOOTER //
// ./src/api/setoranawal.js